
function loadPage(component, path = '') {
  // '@' is aliased to src/module
  let importPath = (path) ? path + '/' : '';
  return () => import(`@/components/page/` + importPath + `${component}.vue`)
}

const routes_base = [
  {path: 'mart/order/detail', component: loadPage('OrderDetail', 'mart/order')},
  {path: 'mart/order_list_order', component: loadPage('OrderListOrder', 'mart/order')},
  {path: 'mart/order_list_pay_new', component: loadPage('OrderListPayNew', 'mart/order')},
  {path: 'mart/order_list_pay_all', component: loadPage('OrderListPayAll', 'mart/order')},
  {path: 'mart/order_create', component: loadPage('OrderCreate', 'mart/order')},
  {path: 'mart/order_list_goods_new', component: loadPage('OrderListGoodsNew', 'mart/goods')},
  {path: 'mart/order_list_goods_all', component: loadPage('OrderListGoodsAll', 'mart/goods')},
  {path: 'mart/order_list_delivery_new', component: loadPage('OrderListDeliveryNew', 'mart/delivery')},
  {path: 'mart/order_list_deliverying', component: loadPage('OrderListDeliverying', 'mart/delivery')},
  {path: 'mart/order_list_delivery_all', component: loadPage('OrderListDeliveryAll', 'mart/delivery')},
  {path: 'mart/order_list_delivery_success', component: loadPage('OrderListDeliverySuccess', 'mart/delivery')},
  {path: 'mart/order_list_settle', component: loadPage('OrderListSettle', 'mart/delivery')},
  {path: 'mart/order_list_cancel_new', component: loadPage('OrderListCancelNew', 'mart/cancel')},
  {path: 'mart/order_list_cancel_all', component: loadPage('OrderListCancelAll', 'mart/cancel')},
  {path: 'mart/order_list_back_new', component: loadPage('OrderListReturnNew', 'mart/return')},
  {path: 'mart/order_list_back_all', component: loadPage('OrderListReturnAll', 'mart/return')},
  {path: 'mart/order_list_backing', component: loadPage('OrderListReturning', 'mart/return')},
  {path: 'mart/order_list_refund_new', component: loadPage('OrderListRefundNew', 'mart/refund')},
  {path: 'mart/order_list_refund_all', component: loadPage('OrderListRefundAll', 'mart/refund')},
  {path: 'mart/order_setting', component: loadPage('OrderSetting', 'mart/order') },
  // 정산
  { path: 'mart/account/new', component: loadPage('AccountNew', 'mart/account') },
  { path: 'mart/account/all', component: loadPage('AccountAll', 'mart/account') },
  { path: 'mart/account/setting', component: loadPage('AccountSetting', 'mart/account') },

  // 포인트
  { path: 'mart/point/setting', component: loadPage('PointSetting', 'point') },

  // 배송 가능 시간 설정
  { path: 'mart/partner_delivery_time/setting', component: loadPage('PartnerDeliveryTimeSetting', 'partner') },
  { path: 'mart/partner/product/detail', component: loadPage('MartPartnerProductDetail', 'mart')},

  { path: 'mart/order/statistics/day', component: loadPage('MartOrderStatisticsDay', 'mart/statistics')},
  { path: 'mart/order/statistics/week', component: loadPage('MartOrderStatisticsWeek', 'mart/statistics')},
  { path: 'mart/order/statistics/month', component: loadPage('MartOrderStatisticsMonth', 'mart/statistics')},

  { path: 'mart/order/statistics/product', component: loadPage('MartOrderStatisticsProduct', 'mart/statistics')},

];


const routes_admin = [

];


const routes = {
  'base': routes_base,
  'admin': routes_admin.concat(routes_base),
  'supervisor': routes_base
};

export default routes;

